import { Injectable } from '@angular/core';
import { Toastr } from '../models/Utils/toastr';
import { Subject, Observable } from 'rxjs';
import { CustomerContextService } from './customer-context.service';

@Injectable({
  providedIn: 'root'
})
export class ToastrService {

  constructor(private customerContext: CustomerContextService) { }

  private subject = new Subject<Toastr>();

  addToastr(toastr:Toastr){
    toastr.Message = this.customerContext.displayText(toastr.Message);
    this.subject.next(toastr);
  }

  toastrStream():Observable<Toastr>{
    return this.subject.asObservable();
  }

}
